import {
  ref,
  onMounted,
  defineComponent,
  reactive,
  computed,
} from "@vue/composition-api";
// import { formatTotal } from "@/utilities/display-helpers";

import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";

import { CommodityInventorySummary } from "@/models/CommodityInventorySummary";

// import { delayController, DelayReturnStatus } from "@/controllers/delay";
import { commodityInventorySummariesController } from "@/controllers/commodityInventorySummaries";
import { JSConn } from "@/utilities/js-conn";
import { itemRouteBuilder, NamedRts } from "@/router";

import { genericSort, sortIcon } from "@/components/helpers";
import { SellContract } from "@/models/SellContract";
import { InventoryLot } from "@/models/InventoryLot";

import ListPageHeader from "@/components/ListPageHeader/ListPageHeader.vue";

export default defineComponent({
  name: "commodityInventorySummaryShow",
  components: {
    LoadingAnimation,
    ListPageHeader,
  },
  props: {
    commodityId: {
      type: String,
      required: true,
    },
  },

  setup(props, ctx) {
    const $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const loadingMessage =
      "Please wait while the summary for the commodity is generated...";

    const showMenu = ref(false);

    const ilShowRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.inventoryLotDetails, id);
    };

    const scShowRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.sellContractDetails, id);
    };

    const apiCommodityInventorySummary = computed(() => {
      return $store.getters
        .commodityInventorySummary as CommodityInventorySummary;
    });

    const sellContracts = ref<SellContract[]>([]);
    const inventoryLots = ref<InventoryLot[]>([]);

    const ilSortAsc = ref(true);
    const scSortAsc = ref(true);

    const ilSortKey = ref<keyof InventoryLot>("label");
    const scSortKey = ref<keyof SellContract>("label");

    const ilUpdateSort = (lSortKey: keyof InventoryLot) => {
      inventoryLots.value = genericSort(
        [...inventoryLots.value],
        ilSortAsc,
        ilSortKey,
        lSortKey,
      );
    };

    const scUpdateSort = (lSortKey: keyof SellContract) => {
      sellContracts.value = genericSort(
        [...sellContracts.value],
        scSortAsc,
        scSortKey,
        lSortKey,
      );
    };

    const ilSortIcon = (lSortKey: keyof InventoryLot) => {
      return sortIcon(ilSortAsc, ilSortKey, lSortKey);
    };

    const scSortIcon = (lSortKey: keyof SellContract) => {
      return sortIcon(scSortAsc, scSortKey, lSortKey);
    };

    onMounted(() => {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: props.commodityId,
      };

      Promise.all([
        commodityInventorySummariesController.needCommodityInventorySummary(
          jsConn,
        ),
        // delayController.delay(150, DelayReturnStatus.resolve),
      ]).then(() => {
        sellContracts.value = [
          ...apiCommodityInventorySummary.value.sell_contracts,
        ];
        inventoryLots.value = [
          ...apiCommodityInventorySummary.value.inventory_lots,
        ];

        // flip the sort, otherwise on load it would be off
        ilSortAsc.value = !ilSortAsc.value;
        scSortAsc.value = !scSortAsc.value;
        ilUpdateSort(ilSortKey.value);
        scUpdateSort(scSortKey.value);

        dataLoaded.value = true;
      });
    });

    return {
      dataLoaded,
      loadingMessage,
      showMenu,

      apiCommodityInventorySummary,
      ilShowRouteBuilder,
      scShowRouteBuilder,

      sellContracts,
      inventoryLots,

      ilUpdateSort,
      scUpdateSort,

      ilSortIcon,
      scSortIcon,
    };
  },
});
